import { Box, Title, Button, Text, Stack } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import Link from "next/link";

import { useSearchRouteInfo } from "hooks/routing";
import { dictionaryToSearchParams } from "utils/utils";

export function ExplorerNoResults() {
  const { baseRoute, query } = useSearchRouteInfo();
  const clearRoute = `${baseRoute}/${dictionaryToSearchParams({
    title: query.title,
    level: query.level,
    jobFamily: query.jobFamily,
  })}`;

  return (
    <Box p={40}>
      <Stack gap={36} align="center">
        <Box
          bg="orange.7"
          h={80}
          w={80}
          sx={{
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <IconAlertCircle size={40} color="white" />
        </Box>
        <Stack ta="center" gap={10}>
          <Title c="gray.8" order={3}>
            No Results
          </Title>
          <Text c="gray.6">There are currently no pay ranges to view based on your selection.</Text>
        </Stack>
        <Button
          // @ts-ignore
          variant="secondary"
          fullWidth={false}
          size="lg"
          component={Link}
          href={clearRoute}
        >
          Clear All Filters
        </Button>
      </Stack>
    </Box>
  );
}
